/* Fluvora: koszyk (szuflada), galeria, wariant, ilość, menu, pasek zakupu na telefonie. */
(function () {
  'use strict';
  var T = window.themeCart || {};
  var ROOT = T.root || '/';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  var nf = null;
  try { nf = new Intl.NumberFormat(document.documentElement.lang || 'pl', { style: 'currency', currency: T.currency || 'PLN' }); } catch (e) {}
  function fmt(c) { return nf ? nf.format(c / 100) : (c / 100).toFixed(2) + ' ' + (T.currency || ''); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var ICONS = {
    plus: '<path d="M12 5v14M5 12h14"/>',
    minus: '<path d="M5 12h14"/>'
  };
  function icon(n, size) { size = size || 24; return '<svg class="icon" width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + ICONS[n] + '</svg>'; }

  /* ---- menu mobilne ---- */
  function closeMenu() { var m = $('#navm'), b = $('[data-menu]'); if (m) m.hidden = true; if (b) b.setAttribute('aria-expanded', 'false'); }
  function toggleMenu() { var m = $('#navm'), b = $('[data-menu]'); if (!m) return; var open = m.hidden; m.hidden = !open; b.setAttribute('aria-expanded', String(open)); }

  /* ---- koszyk ---- */
  var lastFocus = null;
  function openCart() { var d = $('[data-drawer]'); if (!d) return; lastFocus = document.activeElement; d.hidden = false; document.body.classList.add('noscroll'); var c = $('.drawer__head .icon-btn'); if (c) c.focus(); }
  function closeCart() { var d = $('[data-drawer]'); if (!d || d.hidden) return; d.hidden = true; document.body.classList.remove('noscroll'); if (lastFocus && lastFocus.focus) lastFocus.focus(); }
  function getCart() { return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function renderCart(cart) {
    var n = cart.item_count;
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
    var body = $('[data-drawer-body]'), foot = $('[data-drawer-foot]');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="empty"><p>Twój koszyk jest pusty.</p><a class="btn btn--primary" href="' + ROOT + 'collections/all">Przejdź do katalogu</a></div>';
      foot.innerHTML = '';
      return;
    }
    body.innerHTML = '<div style="display:grid;gap:12px">' + cart.items.map(function (l) {
      var img = (T.images && T.images[l.handle]) || l.image || '';
      var vt = (l.variant_title && l.variant_title !== 'Default Title') ? '<span class="muted" style="font-size:.9rem">' + esc(l.variant_title) + '</span>' : '';
      return '<div class="line"><div class="line__img">' + (img ? '<img src="' + esc(img) + '" alt="" width="144" height="144">' : '') + '</div><div class="line__body"><strong>' + esc(l.product_title) + '</strong>' + vt +
        '<div class="line__row"><div class="qty" role="group" aria-label="Ilość"><button type="button" data-line="' + esc(l.key) + '" data-q="' + (l.quantity - 1) + '" aria-label="Zmniejsz ilość">' + icon('minus', 18) + '</button><output>' + l.quantity + '</output><button type="button" data-line="' + esc(l.key) + '" data-q="' + (l.quantity + 1) + '" aria-label="Zwiększ ilość">' + icon('plus', 18) + '</button></div>' +
        '<strong>' + fmt(l.final_line_price) + '</strong><button class="line__rm" type="button" data-line="' + esc(l.key) + '" data-q="0">Usuń</button></div></div></div>';
    }).join('') + '</div>';
    foot.innerHTML = '<p class="sum"><span>Suma częściowa</span><strong>' + fmt(cart.total_price) + '</strong></p><p class="muted" style="font-size:.88rem">Koszt dostawy zostanie obliczony przy finalizacji zamówienia.</p>' +
      '<a class="btn btn--primary btn--xl" href="' + ROOT + 'checkout">Przejdź do kasy</a>';
  }
  function refreshCart() { return getCart().then(renderCart); }
  function addToCart(id, qty, errEl) {
    if (errEl) errEl.hidden = true;
    return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Błąd'); return j; }); })
      .then(function () { return refreshCart(); })
      .then(openCart)
      .catch(function (e) { if (errEl) { errEl.textContent = 'Nie udało się dodać do koszyka: ' + e.message; errEl.hidden = false; } });
  }
  function changeLine(key, q) {
    fetch(ROOT + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, q) }) })
      .then(function (r) { return r.json(); }).then(renderCart);
  }

  /* ---- produkt ---- */
  var gIdx = 0;
  function setImg(i) {
    var th = $$('.thumb'); if (!th.length) return;
    gIdx = (i + th.length) % th.length;
    var im = $('[data-gallery-img]'), t = th[gIdx];
    if (im) { im.src = t.getAttribute('data-full'); im.alt = t.getAttribute('data-alt') || ''; }
    th.forEach(function (x, k) { x.setAttribute('aria-pressed', String(k === gIdx)); });
    var box = t.parentNode; if (box.scrollWidth > box.clientWidth) box.scrollTo({ left: t.offsetLeft - 16 });
  }
  function selectedId() {
    var f = $('#product-form'); if (!f) return null;
    var r = $('input[name=id]:checked', f);
    var h = $('input[type=hidden][name=id]', f);
    return (r || h) ? (r || h).value : null;
  }
  function qtyVal() { var q = $('[data-qty-input]'); return q ? Math.max(1, Number(q.value) || 1) : 1; }
  function updateVariant() {
    var f = $('#product-form'); if (!f) return;
    var r = $('input[name=id]:checked', f);
    if (!r) return;
    var p = $('[data-price]'), sp = $('[data-sticky-price]');
    if (p) p.textContent = r.getAttribute('data-price');
    if (sp) sp.textContent = r.getAttribute('data-price');
    var av = r.getAttribute('data-available') === 'true';
    var b = $('[data-add-main]'), l = $('[data-add-label]');
    if (b) b.disabled = !av; if (l) l.textContent = av ? 'Dodaj do koszyka' : 'Wyprzedane';
    var s = $('[data-add-sticky]'); if (s) s.disabled = !av;
  }
  function setQty(n) {
    n = Math.max(1, Math.min(99, n));
    var q = $('[data-qty-input]'), o = $('[data-qty-out]'); if (q) q.value = n; if (o) o.textContent = n;
  }
  function addMain() {
    var id = selectedId(); if (!id) return;
    addToCart(id, qtyVal(), $('[data-add-error]'));
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-skip]')) { e.preventDefault(); var a = $('#app'); if (a) a.focus(); return; }
    if (t.closest('[data-menu]')) { toggleMenu(); return; }
    var co = t.closest('[data-cart-open]');
    if (co) { e.preventDefault(); refreshCart().then(openCart); return; }
    if (t.closest('[data-cart-close]')) { closeCart(); return; }
    var add = t.closest('[data-add]'); if (add) { addToCart(add.getAttribute('data-add'), 1); return; }
    if (t.closest('[data-add-sticky]')) { addMain(); return; }
    var th = t.closest('[data-thumb]'); if (th) { setImg(Number(th.getAttribute('data-thumb'))); return; }
    var gal = t.closest('[data-gal]'); if (gal) { setImg(gIdx + Number(gal.getAttribute('data-gal'))); return; }
    var q = t.closest('[data-qty]'); if (q) { setQty(qtyVal() + Number(q.getAttribute('data-qty'))); return; }
    var ln = t.closest('[data-line]'); if (ln) { changeLine(ln.getAttribute('data-line'), Number(ln.getAttribute('data-q'))); return; }
  });
  document.addEventListener('submit', function (e) {
    if (e.target.id === 'product-form') { e.preventDefault(); addMain(); }
  });
  document.addEventListener('change', function (e) { if (e.target.name === 'id') updateVariant(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); closeMenu(); }
    var main = document.activeElement && document.activeElement.closest && document.activeElement.closest('[data-gallery-main]');
    if (main && e.key === 'ArrowLeft') setImg(gIdx - 1);
    if (main && e.key === 'ArrowRight') setImg(gIdx + 1);
  });
  var sx = null;
  document.addEventListener('touchstart', function (e) { var m = e.target.closest && e.target.closest('[data-gallery-main]'); sx = m ? e.touches[0].clientX : null; }, { passive: true });
  document.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; sx = null; if (Math.abs(dx) > 40) setImg(gIdx + (dx < 0 ? 1 : -1)); }, { passive: true });

  function init() {
    var bar = $('[data-sticky]'), btn = $('[data-add-main]');
    if (bar && btn) {
      document.body.classList.add('has-sticky');
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { bar.hidden = en[0].isIntersecting || en[0].boundingClientRect.top > 0; }, { threshold: 0 }).observe(btn);
      }
    }
    updateVariant();
    if ($('[data-drawer-body]')) refreshCart();
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
